"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedovercast = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 57 48",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedovercast` : '') + (description ? ` desc-brandedovercast` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedovercast"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedovercast"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "m32.53 17.32-5.3 3a.95.95 0 0 0-.44 1.07l1.62 5.86a.94.94 0 0 1-1.16 1.16l-5.86-1.62a.95.95 0 0 0-1.07.44l-3 5.3a.94.94 0 0 1-1.64 0l-3-5.3a.95.95 0 0 0-1.07-.44L5.75 28.4a.94.94 0 0 1-1.16-1.16l1.62-5.86a.94.94 0 0 0-.44-1.07l-5.3-3a.94.94 0 0 1 0-1.64l5.3-3a.95.95 0 0 0 .44-1.07L4.6 5.75a.94.94 0 0 1 1.16-1.16l5.86 1.62a.95.95 0 0 0 1.07-.44l3-5.3a.94.94 0 0 1 1.64 0l3 5.3c.21.37.65.55 1.07.44l5.86-1.62a.94.94 0 0 1 1.16 1.16l-1.62 5.86c-.11.42.07.86.44 1.07l5.3 3a.94.94 0 0 1 0 1.64Z",
    fill: "#F7B941"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.2 26.26a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z",
    fill: "#FFDC9C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M56.34 30.74c0-4.37-3.09-8-7.15-8.77a13.13 13.13 0 0 0-12.1-8.2c-4.74 0-8.88 2.57-11.18 6.41a9.86 9.86 0 0 0-5.88-1.94 10.1 10.1 0 0 0-9.66 7.42C5.3 24.36.35 27.84.35 32.53c0 4.69 4.83 8.13 9.93 6.89a7.83 7.83 0 0 0 6.7 3.82 7.8 7.8 0 0 0 6.1-2.95 13.96 13.96 0 0 0 12.27 7.42c5.3 0 10.31-3.3 12.58-8.05a8.84 8.84 0 0 0 8.42-8.91h-.01Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.93 39.65a8.69 8.69 0 0 0 8.41-8.67v-.1c0-4.41-3.09-8.18-7.15-8.95a13.2 13.2 0 0 0-4.92-5.96 106.23 106.23 0 0 1-31.42 26.08 6.91 6.91 0 0 0 4 1.24 8.04 8.04 0 0 0 6.22-3 13.94 13.94 0 0 0 12.27 7.48c5.3 0 10.31-3.32 12.58-8.12h.01Z",
    fill: "#C0C0C0"
  }));
};
var _default = exports.default = brandedovercast;